import { environment } from 'environments/environment';
import { Moment } from 'moment';
export class SimuladoresDetalle {
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Label_id_soles=environment.ID_GUIA_SOLES;
  checked:any;
  idComprobante: number=0;
  Tipo_Comprobante:string;
  Serie:any;
  Numero:any;
  Fecha_de_Pago: Moment;
  Plazo =  0;
  VNPP  = '0.00';
  Valor_Venta = '0.00';
  IGV_Factura_Porcentaje = '0.18';
  IGV_Factura_Importe ='0.00';
  Precio_Venta = '0.00';
  Total_Honorario = '0.00';
  Retencion_RH_Porcentaje = 0;
  Retencion_RH_Importe = '0.00';
  Total_Recibido = '0.00';
  Detraccion_Porcentaje = 0;
  Detraccion_Importe = 0;
  Retencion_Porcentaje = 0;
  Retencion_Base: number = 72;
  Retencion_Importe = 0;
  Fondo_Garantia_Porcentaje = 0;
  Fondo_Garantia_Base:number = 72 ;
  Fondo_Garantia_Importe = 0;
  Otros_Descuentos = '0.00';
  Adelanto = 0;
  Interes = 0;
  Comision = 0;
  Desembolso = 0;
  Remanente = 0;
  TEM = 0;
  pPAdelanto = 0;
  Moneda: number = this.Label_id_soles;
  IGV = 0;
  Porcentaje_Interes_Adquirente: number;
  InteresAdq = 0;
  InteresProv = 0;
  IGVProv = 0;
  DesembolsoProvConfirming= 0;
  ComisionTotal = 0;
  Tipo_Servicio = this.Id_Factoring;
  Comision_importe= 0;
  CAVALI_importe= 0;
  firma_importe= 0;
  otros_importe= 0; 
  Aforo_Porcentaje= 0; 
  nroFacturas=0;
  FlagObjetivo=false;
  Comision_porcentaje=0;
}
